import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 100;
const START_LEFT = 9;
const MIN_LEFT = 3;
export function ScarcityBar() {
  const [left, setLeft] = useState(START_LEFT);
  useEffect(() => {
    const id = window.setInterval(() => {
      setLeft(v => v > MIN_LEFT ? v - 1 : v);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const filled = (TOTAL_SPOTS - left) / TOTAL_SPOTS * 100;
  return <div className="w-full rounded-2xl bg-danger-pale p-4 ring-1 ring-danger/20" data-id="element-303" data-mp="2g5tjo3j9qavf">
      <p className="flex items-center justify-center gap-2 text-center text-[15px] font-bold text-danger" data-id="element-304" data-mp="2g3ql2v41v9f3">
        <FlameIcon aria-hidden="true" className="h-5 w-5 shrink-0" data-id="element-305" data-mp="228erws5jlr0a" />
        <span data-id="element-306" data-mp="275omsnbpauvi">Only {left} spots left at the promotional price!</span>
      </p>
      <div className="relative mt-3 h-5 w-full overflow-hidden rounded-full bg-white ring-1 ring-danger/20" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-307" data-mp="fqlk9xlqnga">
        <div className="relative h-full overflow-hidden rounded-full bg-danger transition-[width] duration-300 ease-out" style={{
        width: `${filled}%`
      }} data-id="element-308" data-mp="2zk8c0a2pna4b">
          <span className="animate-bar-shine absolute inset-y-0 left-0 w-1/3 bg-white/25" aria-hidden="true" data-id="element-309" data-mp="38d39uipum3k2" />
        </div>
      </div>
      <p className="mt-2 text-center text-xs font-semibold text-navy" data-id="element-310" data-mp="2koix0vvxzx93">{Math.round(filled)}% of introductory spots claimed</p>
    </div>;
}